import { LeaderboardVariant } from "@ecologi/react-components/src/LeaderboardVariant";
import { LeaderboardPathType } from "../../lib";
import { LeaderboardPage } from "../../features";
import { withLogging } from "../../lib/ssr/logGetServerSideProps";

export default function Page() {
  return (
    <LeaderboardPage
      variant={LeaderboardVariant.Business}
      url={LeaderboardPathType.Business}
      title="Business Tree"
      tagline="A leaderboard for our Ecologi business members. Can your business be into the top 10?"
    />
  );
}

export const getServerSideProps = withLogging(async () => {
  const props = await LeaderboardPage.prefetchData(
    LeaderboardVariant.Business,
    LeaderboardPathType.Business
  );

  return {
    props,
  };
});
